<template>
  <div class="form-container">
    <v-row class="main-row" no-gutters>
      <v-col cols="4" class="pa-4">
        <div class="champs">
          <div class="ligne">
            <div class="nom">{{ $t('_societe_') }} (*)</div>
            <div class="complement"> - {{ $t('_nom_de_la_societe_cliente_') }}</div>
          </div>
          <v-text-field color="orange" outlined dense class="inputField" v-model="reponse.societe.value" hide-details="auto"></v-text-field>
        </div>

        <div class="champs mt-3">
          <div class="ligne">
            <div class="nom">{{ $t('_nom_du_projet_') }} (*)</div>
            <div class="complement"> - {{ $t('_nom_du_site_') }}</div>
          </div>
          <v-text-field color="orange" outlined dense class="inputField" v-model="reponse.nom.value" hide-details="auto"></v-text-field>
        </div>

        <div class="champs mt-3">
          <div class="nom">{{ $t('_adresse_') }} (*)</div>
          <v-text-field color="orange" outlined dense class="inputField" v-model="reponse.adresse.value" @input="geocodeAddress" hide-details="auto"></v-text-field>
        </div>

        <div class="champs mt-5">
          <div class="nom">{{ $t('_date_de_mise_en_service_') }} (*)</div>
          <input class="date-custom" type="date" v-model="reponse.elecDate.value" />

          <div class="nom mt-4">{{ $t('_puissance_souscrite_') }}</div>
          <div class="input-with-unit">
            <v-text-field 
              color="orange" 
              outlined 
              dense 
              class="inputField" 
              v-model="reponse.puissanceSouscrite.value"
              hide-details="auto"
              onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))"
            ></v-text-field>
            <div class="unit-text"> kVA</div>
          </div>

          <div class="nom mt-4">{{ $t('_tarif_de_rachat_') }}</div>
          <div class="input-with-unit">
            <v-text-field 
              color="orange" 
              outlined 
              dense 
              class="inputField" 
              v-model="reponse.tarif.value"
              hide-details="auto"
              onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))"
            ></v-text-field>
            <div class="unit-text"> €/kWh</div>
          </div>

          <div class="nom mt-4">{{ $t('_pays_') }} (*)</div>
          <v-text-field color="orange" outlined dense class="inputField" v-model="reponse.pays.value" hide-details="auto"></v-text-field>
        </div>
      </v-col>

      <v-col cols="8" class="pa-4">
        <div class="map-wrapper" style="position: relative;">
          
          <v-btn
            absolute
            top
            right
            small
            color="white"
            class="mt-2 mr-2"
            style="z-index: 1000;"
            @click="switchMapLayer"
          >
            <v-icon left small>mdi-layers</v-icon>
            {{ tileProviders[0].visible ? 'Plan' : 'Satellite' }}
          </v-btn>

          <l-map ref="refMap" class="small-map" :zoom="zoom" :center="centre" style="height: 403px;" @ready="map_ready"
              @update:zoom="zoomUpdated" @update:center="centerUpdated" @update:contours="boundsUpdated">
              <l-tile-layer v-for="tileProvider in tileProviders" :key="tileProvider.name"
                  :name="tileProvider.name" :visible="tileProvider.visible" :url="tileProvider.url"></l-tile-layer>
              <l-marker ref="mapRef" :draggable="true"
                  :lat-lng="[reponse.markerLatLng0.value, reponse.markerLatLng1.value]">
              </l-marker>
          </l-map>
        </div>

        <div class="d-flex mt-4" style="gap:15px;">
          <div style="flex:1">
            <div class="nom">{{ $t('_code_postal_') }} (*)</div>
            <v-text-field color="orange" outlined dense class="inputField" v-model="reponse.codePostal.value" @input="geocodeAddress" hide-details="auto"></v-text-field>
          </div>
          <div style="flex:1">
            <div class="nom">{{ $t('_commune_') }} (*)</div>
            <v-text-field color="orange" outlined dense class="inputField" v-model="reponse.ville.value" @input="geocodeAddress" hide-details="auto"></v-text-field>
          </div>
        </div>

        <div class="d-flex mt-4" style="gap:15px;">
          <div style="flex:1">
            <div class="ligne">
              <div class="nom">{{ $t('_latitude_') }} (*)</div>
              <div class="complement"> - {{ $t('_valeur_decimale_') }}</div>
            </div>
            <v-text-field color="orange" outlined dense class="inputField" v-model="reponse.markerLatLng0.value"
                hide-details="auto"
                onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))"></v-text-field>
          </div>

          <div style="flex:1">
            <div class="ligne">
              <div class="nom">{{ $t('_longitude_') }} (*)</div>
              <div class="complement"> - {{ $t('_valeur_decimale_') }}</div>
            </div>
            <v-text-field color="orange" outlined dense class="inputField" v-model="reponse.markerLatLng1.value"
                hide-details="auto"
                onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))"></v-text-field>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { debounce } from 'lodash';
import moment from 'moment-timezone';
import api from "@/api/api";

export default {
    components: { LMap, LTileLayer, LMarker },
    props: { initDescr: { required: false } },
    data() {
        return {
            UTCs: moment.tz.names(),
            zoom: 5,
            reponse: {
                societe: { value: "", required: true },
                nom: { value: "", required: true },
                adresse: { value: "", required: true },
                codePostal: { value: "", required: true },
                ville: { value: "", required: true },
                pays: { value: "", required: true },
                markerLatLng0: { value: 46.2276, required: true }, 
                markerLatLng1: { value: 2.2137, required: true },
                elecDate: { value: "", required: true },
                puissanceSouscrite: { value: null, required: false },
                prm: { value: null, required: false },
                tarif: { value: 0.1, required: false }
            },
            namelastcompany: "",
            centre: [48.866667, 2.333333],
            // MODIFICATION: Configuration des providers pour le switch
            tileProviders: [
                {
                    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png",
                    visible: true, // Satellite par défaut
                    name: "satelliteESRI",
                },
                {
                  url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                  visible: false, // Plan caché par défaut
                  name: "OpenStreetMap",
                  attribution:
                    '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                },
            ],
        }
    },

    watch: {
        reponse: {
            handler() {
                this.iscomplete();
                let onlyValues = {};
                for (let champ in this.reponse) {
                    onlyValues[champ] = this.reponse[champ].value;
                }
                this.$emit("answer", onlyValues);
            }, deep: true
        },
        initDescr: { handler() { this.getInitValues() }, deep: true }
    },
    mounted() { this.getInitValues() },
    methods: {
        zoomUpdated(z) { this.zoom = z; },
        centerUpdated(c) { this.centre = c; },
        boundsUpdated(b) { this.contours = b; },
        
        // AJOUT: Méthode pour basculer les cartes
        switchMapLayer() {
            this.tileProviders.forEach(provider => {
                provider.visible = !provider.visible;
            });
        },

        geocodeAddress: debounce(function () {
            this.adresseToCoordonnees().then(coords => {
                if (coords) {
                    this.reponse.markerLatLng0.value = coords.latitude;
                    this.reponse.markerLatLng1.value = coords.longitude;
                    this.centre = [coords.latitude, coords.longitude];
                }
            });
        }, 1000),
        async adresseToCoordonnees() {
            const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(this.reponse.adresse.value + " " + this.reponse.codePostal.value + " " + this.reponse.ville.value)}`;
            try {
                const res = await fetch(url);
                const data = await res.json();
                return data.length > 0 ? { latitude: data[0].lat, longitude: data[0].lon } : null;
            } catch (e) { return null; }
        },

        async loadUserData() {
            try {
                const res = await api.currentUser();
                const companyList = res.data.policies.company_list;
                
                if (Array.isArray(companyList) && companyList.length > 0) {
                    const lastItem = companyList.at(-1); 
                    return lastItem;
                }
                return null;
            } catch (e) {
                console.error("Erreur :", e);
                return null;
            }
        },

        async searchNameCompany(company_id) {
          try {
            const res = await api.getCompanyById(company_id);
            const companyData = res.data.name;
            return companyData;
          } catch (e) {
            console.error("Erreur lors de la recherche du nom de la société :", e);
            return null;
          }
        },

        map_ready() {
            this.$refs.mapRef.mapObject.on('dragend', () => {
                this.reponse.markerLatLng0.value = this.$refs.mapRef.mapObject._latlng.lat;
                this.reponse.markerLatLng1.value = this.$refs.mapRef.mapObject._latlng.lng;
            });
        },
        iscomplete() {
            let complete = true;
            for (let c in this.reponse) {
                if (this.reponse[c].required && (this.reponse[c].value === "" || this.reponse[c].value === null)) complete = false;
            }
            this.$emit(complete ? "enable" : "disable");
        },
        async getInitValues() {
            const today = new Date();
            const lastcompanyid = await this.loadUserData();
            if (lastcompanyid && !String(lastcompanyid).includes("[object Promise]")) {
              this.reponse.societe.value = await this.searchNameCompany(lastcompanyid);
            } else {
              this.reponse.societe.value = "";
            }
            
            this.reponse.elecDate.value = today.toISOString().substr(0, 10);
            if (this.initDescr) {
                for (let c in this.initDescr) {
                    if (this.reponse[c]) this.reponse[c].value = this.initDescr[c];
                }
                this.centre = [this.reponse.markerLatLng0.value, this.reponse.markerLatLng1.value];
            }
        }
    }
}
</script>

<style scoped>
.form-container {
    display: flex;
    flex-wrap: wrap;
    background-color: white; /* Assure un fond propre */
}

.main-row {
    width: 100%;
    margin: 0 !important;
}

.ligne {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
}

.nom {
    font-size: 0.9rem;
    font-weight: 500;
    color: #333;
}

.complement {
    font-size: 0.75rem;
    color: #777;
    font-weight: normal;
}

/* Style de l'input date pour matcher Vuetify */
.date-custom {
    width: 100%;
    height: 40px;
    padding: 8px 12px;
    font-size: 0.9rem;
    border: 1px solid rgba(0, 0, 0, 0.24);
    border-radius: 4px;
    outline: none;
    transition: border-color 0.2s;
}

.date-custom:focus {
    border: 2px solid orange;
    padding: 7px 11px; /* Compense l'épaisseur de bordure */
}

/* Alignement du tarif et de l'unité */
.input-with-unit {
    display: flex;
    align-items: center;
}

.unit-text {
    padding-left: 10px;
    font-size: 0.9rem;
    color: #555;
    white-space: nowrap;
}

/* Nettoyage Leaflet */
.map-wrapper {
    border-radius: 4px;
    overflow: hidden; /* Coupe les débordements de bordure de la carte */
    border: 1px solid rgba(0,0,0,0.1);
}

.small-map {
    z-index: 1;
}

/* Supprime les lignes fantômes potentielles sur les colonnes */
.v-col {
    position: relative;
}

/* Force la densité des champs pour un look plus moderne */
::v-deep .v-input--dense .v-input__control {
    min-height: 40px !important;
}
</style>
